import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Identity } from './components/Identity';
import { Manifesto } from './components/Manifesto';
import { Philosophy } from './components/Philosophy';
import { Projects } from './components/Projects';
import { ClientWork } from './components/ClientWork';
import { Presence } from './components/Presence';
import { Roadmap } from './components/Roadmap';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-void font-sans text-ink-hi" data-id="element-0" data-mp="2mmvlkvs92ic2">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-teal focus:px-4 focus:py-2 focus:font-mono focus:text-sm focus:text-void" data-id="element-1" data-mp="31agoaol7qfjg">
        Saltar al contenido
      </a>
      <Nav data-id="element-2" data-mp="28s2y9b64bxux" />
      <main id="main" data-id="element-3" data-mp="23vchsmqej08z">
        <Hero data-id="element-4" data-mp="23w4fq47h1a2f" />
        <Identity data-id="element-5" data-mp="23u9vyt7xrnzx" />
        <Manifesto data-id="element-6" data-mp="23ut97wmn5o7m" />
        <Philosophy data-id="element-7" data-mp="23ti8y6semyl9" />
        <Projects data-id="element-8" data-mp="3ik7fqfdqo9q4" />
        <ClientWork data-id="element-9" data-mp="3ikqyfyb7r257" />
        <Presence data-id="element-10" data-mp="3ij65gd4jrr9g" />
        <Roadmap data-id="element-11" data-mp="3ijpet5g4t7bv" />
      </main>
      <Footer data-id="element-12" data-mp="3mlawd43m29se" />
    </div>;
}